export default "__VITE_ASSET__9a6777ad__"